import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component';
import { toast } from 'react-toastify';

import chzIcon from '../../../../../assets/images/chestnyznak.svg';

const SinglePackingItem = (props) => {
  const { barcode, item, tip, setTip } = props;

  return (
    <>
      <div className="packing-item">
        <div className="packing-item-left">
          {item?.specials ? (
            <div className={'tip-wrap'}>
              <div className={'tip-plus'}>
                <i
                  className="fe-plus"
                  onMouseOver={() => setTip([...tip, `${item.productId}-${barcode}`])}
                  onMouseOut={() => setTip(tip.filter((i) => i !== `${item.productId}-${barcode}`))}
                ></i>
              </div>
              {tip.includes(`${item.productId}-${barcode}`) ? (
                <div className={'tip'}>Допвложение</div>
              ) : null}
            </div>
          ) : null}
          <div className="packing-item-name">{item.name}</div>
        </div>
        <div className="packing-item-right">
          <div>{item.barcode}</div>
          <div className="packing-quantity">{`${item.quantity} шт.`}</div>
        </div>
      </div>
      <p style={{ marginBottom: '4px' }}>{item?.variantId}</p>
      {(item?.accountingAttributes ?? []).map((attr) => (
        <div className="packing-item-string" key={attr.code} style={{ color: '#72747ba8' }}>
          <p title={attr.stringValue}>
            {attr.code === 'chestnyznak' ? (
              <img src={chzIcon} style={{ marginTop: '-2px' }} />
            ) : (
              `${attr.code}:`
            )}
            {` ${attr.stringValue}`}
          </p>
          <CopyToClipboard
            text={attr.stringValue}
            onCopy={() => toast.info(`Номер атрибута скопирован`)}
          >
            <i className="fe-copy" />
          </CopyToClipboard>
        </div>
      ))}
      {item?.batchAccountingAttributes?.batchAccountingNumber ? (
        <div>Номер партии: {item.batchAccountingAttributes.batchAccountingNumber}</div>
      ) : null}
      {item?.batchAccountingAttributes?.expirationDate ? (
        <div>Срок годности: {item.batchAccountingAttributes.expirationDate}</div>
      ) : null}
    </>
  );
};

export default SinglePackingItem;
